import { Routes } from '@angular/router';
import { ChartComponent } from './chart/chart.component';

export const routes: Routes = [
  { path: '', redirectTo: '/chart/AAPL', pathMatch: 'full' },
  { path: 'chart/:symbol', component: ChartComponent },
  { path: '**', redirectTo: '/chart/AAPL' }
];
